import React, { useMemo } from 'react';
import { isOldBookingConfirmedTimestamp } from 'utils/booking';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import AlertBox from 'components/ui/AlertBox';
import { StyledAlertBox } from '../Leg.styles';
import { legShape } from 'constants/propTypes';

const isOldConfirmedTimestamp = (journey) =>
  journey.products.some((product) => isOldBookingConfirmedTimestamp(product.confirmedTimestamp)) || false;

const isLoyaltyJourney = (journey) => journey.activeBookingItems.some((item) => item.code.startsWith('LOYALTY'));

const OldJourneyAlertBox = ({ journey, intl }) => {
  const showOldJourneyAlert = useMemo(() => isOldConfirmedTimestamp(journey) && isLoyaltyJourney(journey), [journey]);

  if (!showOldJourneyAlert) {
    return null;
  }

  return (
    <StyledAlertBox
      variant={AlertBox.variants.ERROR}
      tooltips={{
        id: 'old-loyalty-alert-tooltip',
        text: intl.formatMessage({ id: 'journeySegment.oldLoyaltyBookingTooltip' })
      }}
    >
      <FormattedMessage id="journeySegment.oldLoyaltyBooking" />
    </StyledAlertBox>
  );
};

OldJourneyAlertBox.propTypes = {
  journey: legShape.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(OldJourneyAlertBox);
